import React, { useRef, useState } from "react";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";

import { toastError, toastSuccess } from "../../../shared/helpers";
import PageHero from "../../molecules/PageHero";
import { CREATE_ORGANIZATION } from "../../../shared/queries";
import Stepper from "../../molecules/Stepper/Stepper";
import FormOne from "./form.one";
import LoadingBar from "react-top-loading-bar";
import FormTwo from "./form.two";

const steps = [
  {
    title: "Organization Details",
    value: 1,
  },
  {
    title: "Tax Details",
    value: 2,
  },
];

const CreateOrganizationPage = () => {
  const navigate = useNavigate();
  const loader = useRef(null);

  const [currentStep, setCurrentStep] = useState(1);
  const [fields, setFields] = useState({});

  const updateFields = (data) => {
    setFields({ ...fields, ...data });
  };

  const [createOrganization] = useMutation(CREATE_ORGANIZATION);

  const onCreateOrganization = async (data) => {
    if (loader) {
      loader.current.continuousStart();
    }
    let contacts = [];
    let locations = [];
    let phones = [];

    let dataArray = Object.entries({ ...fields, ...data });

    const groupInput = (groupTitle, groupKey, keyInput, array) => {
      const _inputs = array.filter(([key]) => key.includes(groupKey));

      const _inputs_with_key = _inputs.filter(([key]) => key.includes(keyInput));

      _inputs_with_key.forEach((input) => {
        let id = input[0].split("_").pop();
        let group = {};
        _inputs.forEach((input) => {
          if (input[0].includes(id)) {
            let key = input[0].split("_")[1];
            if (key === "languages") {
              const languages =
                input[1].length > 1
                  ? input[1].reduce(
                      (prev, curr) =>
                        (prev.value ? prev.value : prev) + ", " + curr.value,
                    )
                  : input[1][0].value;
              group = {
                ...group,
                languages,
              };
            } else {
              group = {
                ...group,
                [key]: input[1].value ? input[1].value : input[1],
              };
            }
          }
        });
        groupTitle.push(group);
      });
      return groupTitle;
    };

    contacts = groupInput(contacts, "contact", "firstName", dataArray);
    locations = groupInput(locations, "location", "name", dataArray);
    phones = groupInput(phones, "phone", "number", dataArray);

    const combineString = (groupKey, array) => {
      const _inputs = array.filter(([key]) => key.includes(groupKey));

      if (_inputs.length === 0) return;
      let proofsArray = [];

      _inputs.forEach((input) => {
        proofsArray.push(input[1]);
      });
      const groupTitle = proofsArray.join();
      return groupTitle;
    };

    const proofOfRelation = combineString("proof", dataArray);

    const formData = {
      phones,
      locations,
      contacts,
      description: fields.description,
      name: fields.name,
      tagline: fields.tagline,
      alternateName: fields.alternateName,
      email: fields.email,
      url: fields.url,
      ein: fields.ein,
      deductibility: fields.deductibility?.value,
      subsection: fields.eo_subsection?.value,
      assetAmount: fields.asset_amount?.value,
      opCategory: fields.opCategory.value.toLowerCase(),
      subOpCategory: fields.subOpCategory.value,
      nteeType: fields.nteeType.value,
      nteeCode: fields.nteeCode,
      nteeLetter: fields.nteeLetter,
      nteeSuffix: fields.nteeCode.slice(1, 3),
      nteeClassification: fields.nteeClassification.value,
      createdBy: {
        relationshipToOrganization: fields.relationshipToOrganization,
        proofOfRelation,
      },

      incomeAmount: fields.income_code?.value,
      filingRequirement: fields.filing_requirements?.value,
      latest990: fields.latest990,
      rulingDate: fields.rulingDate,
      affiliation: fields.affiliation?.value,
      accountingPeriod: fields.accountingPeriod?.value,
      exemptOrgStatusCode: fields.exemptOrg?.value,
      exemptOrgStatus: fields.exemptOrg?.label,
    };

    createOrganization({
      variables: {
        data: formData,
      },
    })
      .then(() => {
        toastSuccess("Organization created succesfully");
        navigate("/dashboard");
      })
      .catch((error) => {
        toastError(error.message);
        // return loader && loader.current?.complete();
      });
  };

  const formCtx = useForm({
    mode: "onChange",
  });

  return (
    <main>
      <FormProvider {...formCtx}>
        <LoadingBar height={2} color="#00AF72" ref={loader} />
        <PageHero
          title="Create an organization"
          description="Create a listing page for your organization"
        />
        <div className="container md:w-2/5 mx-auto mt-10">
          <Stepper
            steps={steps}
            activeStep={currentStep}
            changeStep={() => console.log(currentStep)}
          />
        </div>

        <div className="lg:w-4/5 mt-20 mx-auto container">
          {currentStep === 1 && (
            <FormOne setCurrentStep={setCurrentStep} updateFields={updateFields} />
          )}
          {currentStep === 2 && (
            <FormTwo onCreateOrganization={onCreateOrganization} />
          )}
        </div>
      </FormProvider>
    </main>
  );
};

export default CreateOrganizationPage;
